import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import DesktopSettingsPage from './SettingsPage';
import MobileSettingsPage from './mobile/MobileSettingsPage';

/**
 * SettingsWrapper component that conditionally renders either the desktop
 * or mobile version of the settings page based on screen size.
 */
const SettingsWrapper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Render the mobile version on small screens, desktop version otherwise
  return isMobile ? <MobileSettingsPage /> : <DesktopSettingsPage />;
};

export default SettingsWrapper; 